import React, { useEffect, useState } from "react";
import type { ISegment } from "@typing/wsui/getMessages";
import type { IAppendAskContent, IAppendAskItem } from "@typing/wsui/getMessages";
import { useChatStore } from "@store/chatStore";
import styles from "./index.module.less";
import { Icon } from "@config/image";
import { useUbcSend } from "@hooks/useUbcSend";
interface IAppendAskProps {
    segment: ISegment;
    messageId: string;
    sessionId: string;
    onAppendAskClick: (question: string) => void;
}

const AppendAsk: React.FC<IAppendAskProps> = ({ segment, messageId, sessionId, onAppendAskClick }) => {
    const { ubcSend } = useUbcSend();

    // 用户点击追问后发送新消息，原消息不再是最后一条，追问自动消失
    const { lastMessageId, sseLoading } = useChatStore((state) => ({
        lastMessageId: state.getLastMessageId(sessionId),
        sseLoading: state.sessions[sessionId]?.sseLoading || false,
    }));
    const isLastMessage = messageId === lastMessageId;
    // 解析追问内容
    const [appendAskData, setAppendAskData] = useState<IAppendAskContent | null>(null);

    useEffect(() => {
        try {
            if (segment.content) {
                const parsedData = JSON.parse(segment.content) as IAppendAskContent;
                setAppendAskData(parsedData);
            }
        } catch (error) {
            console.error("解析追问数据失败:", error);
            setAppendAskData(null);
        }
    }, [segment.content]);

    useEffect(() => {
        if (!isLastMessage || sseLoading) return;

        if (!appendAskData?.list || appendAskData.list.length === 0) {
            return;
        }
        ubcSend({
            type: 'view',
            value: 'appendAsk',
            ext: {
                product_info: {
                    appendAskData: appendAskData.list.map(item => item.content_id).join(','),
                    appendAskMsg: appendAskData.list.map(item => item.content).join(','),
                    message_id: messageId,
                    session_id: sessionId,
                },
            },
        });
    }, [appendAskData, isLastMessage, messageId, sessionId, sseLoading, ubcSend]);

    // 仅在最后一条消息且 SSE 已结束时显示追问
    if (!isLastMessage || sseLoading) return null;

    if (!appendAskData?.list || appendAskData.list.length === 0) {
        return null;
    }

    const handleAppendAskClick = (item: IAppendAskItem) => {
        onAppendAskClick(item.content);
        // 追问埋点
        ubcSend({
            type: 'clk',
            value: 'appendAsk',
            ext: {
                product_info: {
                    message_id: messageId,
                    session_id: sessionId,
                    append_ask_id: item.content_id,
                    append_ask_msg: item.content,
                }
            }
        })

        ubcSend({
            type: 'clk',
            value: 'ask_msg',
            ext: {
                product_info: {
                    ask_type: 'appendAsk',
                    content: item.content,
                }
            }
        })
    }

    return (
        <div className={styles.appendAskContainer}>
            <div className={styles.appendAskList}>
                {appendAskData.list.map((item: IAppendAskItem) => (
                    <div
                        key={item.content_id}
                        className={styles.appendAskItem}
                        onClick={() => handleAppendAskClick(item)}
                    >
                        <span className={styles.appendAskText}>{item.content}</span>
                        <img 
                            src={Icon.rightArrow} 
                            alt="" 
                            className={styles.appendAskArrow}
                        />
                    </div>
                ))}
            </div>
        </div>
    );
};

export default AppendAsk;